export { default } from "./ExpertInfoExpanded";
